import "core-js/modules/web.dom.iterable";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryWarningAnalysis } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '30px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {},
    queryType: {}
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  watch: {
    id: {
      handler: function handler(val) {
        this.querySewageQuotaList(this.type, val, this.queryType);
      },
      immediate: true
    },
    queryType: function queryType(val) {
      this.querySewageQuotaList(this.type, this.id, val);
    }
  },
  methods: {
    initBarChart: function initBarChart(data) {
      var option = {
        "tooltip": {
          "trigger": "axis",
          "axisPointer": {
            "type": "shadow",
            textStyle: {
              color: "#fff"
            }
          }
        },
        "grid": {
          "borderWidth": 0,
          "top": '30%',
          "bottom": '10%',
          textStyle: {
            color: "#fff"
          }
        },
        "legend": {
          x: 'center',
          top: '7%',
          textStyle: {
            color: '#90979c'
          },
          "data": data.legendData
        },
        "calculable": true,
        "xAxis": [{
          "type": "category",
          "axisLine": {
            lineStyle: {
              color: '#90979c'
            }
          },
          "splitLine": {
            "show": false
          },
          "axisTick": {
            "show": false
          },
          "splitArea": {
            "show": false
          },
          "data": data.xData
        }],
        "yAxis": [{
          "type": "value",
          "splitLine": {
            "show": false
          },
          "axisLine": {
            lineStyle: {
              color: '#90979c'
            }
          },
          "axisTick": {
            "show": false
          },
          "axisLabel": {
            "interval": 0
          },
          "splitArea": {
            "show": false
          }
        }],
        "series": data.seriesData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(type, id, queryType) {
      var _this = this;

      queryWarningAnalysis({
        type: type,
        id: id,
        queryType: queryType
      }).then(function (res) {
        if (res.success) {
          var data1 = [],
              data2 = [],
              data3 = [],
              data4 = [];
          var data = {
            xData: [],
            seriesData: [],
            legendData: ['数据报警', '设备报警', '离线报警']
          };
          res.result.forEach(function (v, i) {
            data.xData.push(v.dateStr);
            data1.push(v.dataNum);
            data2.push(v.equipmentNum);
            data3.push(v.offLineNum);
            data4.push(v.dataNum + v.equipmentNum + v.offLineNum);
          });
          data.seriesData = [{
            "name": "数据报警",
            "type": "bar",
            "stack": "总量",
            "barMaxWidth": 35,
            "barGap": "10%",
            "itemStyle": {
              "normal": {
                "color": "rgba(255,144,128,1)",
                "label": {
                  "show": true,
                  "textStyle": {
                    "color": "#fff"
                  },
                  "position": "inside",
                  formatter: function formatter(p) {
                    return p.value > 0 ? p.value : '';
                  }
                }
              }
            },
            "data": data1
          }, {
            "name": "设备报警",
            "type": "bar",
            "stack": "总量",
            "itemStyle": {
              "normal": {
                "color": "rgba(0,191,183,1)",
                "barBorderRadius": 0,
                "label": {
                  "show": true,
                  "position": "inside",
                  formatter: function formatter(p) {
                    return p.value > 0 ? p.value : '';
                  }
                }
              }
            },
            "data": data2
          }, {
            "name": "离线报警",
            "type": "bar",
            "stack": "总量",
            "itemStyle": {
              "normal": {
                "color": "orange",
                "barBorderRadius": 0,
                "label": {
                  "show": true,
                  "position": "inside",
                  formatter: function formatter(p) {
                    return p.value > 0 ? p.value : '';
                  }
                }
              }
            },
            "data": data3
          }, {
            "name": "总数",
            "type": "line",
            symbolSize: 10,
            symbol: 'circle',
            "itemStyle": {
              "normal": {
                "color": "red",
                "barBorderRadius": 0,
                "label": {
                  "show": true,
                  "position": "top",
                  formatter: function formatter(p) {
                    return p.value > 0 ? p.value : '';
                  }
                }
              }
            },
            "data": data4
          }];

          _this.initBarChart(data);
        }
      });
    }
  }
};